<template>
  <div>
    <button
      v-for="{ id, icon, name, action } in shareOptions"
      :key="id"
      class="o-button c-share-product__share-button"
      :class="{ 'o-button--color-white': simple }"
      @click.prevent="action"
    >
      <i
        class="o-icon o-button__icon c-share-product__share-button-icon"
        :class="[`o-icon--${icon}`, `c-share-product__share-button-icon--${icon}`]"
      ></i>
      {{ name }}
    </button>
  </div>
</template>
<script>
  import { embeddedCodeMixin } from '@/shared/mixins';
  import { ModalType, ProductType } from '@/shared/enums';
  import { copyToClipboard } from '@/shared/utils';
  import PopupWindow from '@/shared/messaging/popup-window';

  const COPIED_MESSAGE_TIMEOUT = 5000;

  export default {
    name: 'UiShareOptions',
    mixins: [
      embeddedCodeMixin,
    ],
    props: {
      product: {
        type: Object,
        required: true,
      },
      simple: Boolean,
    },
    data() {
      const copyEmbedOption = {
        id: 'copy-embed-code', icon: 'embed', name: this.$t('share.copyEmbedCode'), action: this.copyEmbedCode,
      };
      const showEmbedOption = {
        id: 'get-embed-code', icon: 'embed', name: this.$t('share.getEmbedCode'), action: this.showEmbedCode,
      };
      const shareOptions = [
        { id: 'share-via-facebook', icon: 'facebook', name: this.$t('share.viaFacebook'), action: this.facebookShare },
        { id: 'share-via-twitter', icon: 'twitter', name: this.$t('share.viaTwitter'), action: this.twitterShare },
      ];

      if (this.product.type !== ProductType.SERIAL) {
        shareOptions.push(this.simple ? copyEmbedOption : showEmbedOption);
      }

      return {
        copyEmbedOption,
        shareOptions,
      };
    },
    computed: {
      productLink() {
        return this.product.canonicalUrl;
      },
    },
    methods: {
      facebookShare() {
        const popup = new PopupWindow();

        popup.load(`https://www.facebook.com/sharer.php?u=${this.productLink}`);
      },
      twitterShare() {
        const url = encodeURIComponent(this.productLink);
        const text = encodeURIComponent(document.title);
        const popup = new PopupWindow();

        popup.load(`https://twitter.com/intent/tweet?url=${url}&text=${text}`);
      },
      copyEmbedCode() {
        copyToClipboard(this.embeddedCode);
        this.copyEmbedOption.icon = 'check';
        this.copyEmbedOption.name = this.$t('share.embedCode.copiedInfo');

        setTimeout(() => {
          this.copyEmbedOption.icon = 'embed';
          this.copyEmbedOption.name = this.$t('share.copyEmbedCode');
        }, COPIED_MESSAGE_TIMEOUT);
      },
      showEmbedCode() {
        this.$modal.create({
          id: ModalType.EMBED_CODE,
          component: () => import('@/index/shared/components/modal/embed-code.vue'),
        });
      },
    },
  };
</script>
